import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-atualizar-assinatura',
  templateUrl: './modal-atualizar-assinatura.component.html',
  styleUrls: ['./modal-atualizar-assinatura.component.scss']
})
export class ModalAtualizarAssinaturaComponent implements OnInit {

  constructor(
    private readonly activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void { }

  public cancelamento(): void {
    this.activeModal.close(false);
  }
  public confirmacao(): void {
    this.activeModal.close(true);
  }
}
